import { CommonModule } from '@angular/common';
import { Component, input, output, OnInit } from '@angular/core';
import { AbstractControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';

@Component({
    imports: [CommonModule, MatInputModule, ReactiveFormsModule, MatDatepickerModule, MatNativeDateModule],
    selector: 'app-date-picker',
    templateUrl: './date-picker.component.html',
    styleUrls: ['./date-picker.component.scss'],
    standalone: true,
})

export class DatePickerComponent implements OnInit {

    public formField: AbstractControl;
    group = input<FormGroup>();
    type = input<string>();
    name = input<string>();
    class = input<string>();
    label = input<string>();
    required = input<boolean>();
    readonly = input<boolean>();
    isDisabled = input<boolean>(false);
    isFormSubmitted = input<boolean>(true);
    public dateChange = output<any>();
    public modelValueChange = output<any>();
    maxDate = input<any>();
    placeholder = input<string>('');
    minDate = input<any>();
    isErrorOnChange = input<boolean>(false);
    dateError = input<boolean>();
    public date: any
    public default = true;
    today = new Date();
    customError = input<string>('');

    ngOnInit() {
        // Preserving existing logic, though 'this.date' seems shadowed in template by #date
        if (this.name()) {
            this.date = this.name();
        }
        if (this.group() && this.name()) {
            this.formField = this.group().controls[this.name()];
        }
    }

    opened = true;

    preventE(event: any) {
        event.preventDefault();
    }

    deleteEvent(event: any) {
        if (event.keyCode === 9) {
            return
        }
        if (event.keyCode === 8) {
            this.group().get(this.name())?.reset();
            return
        }
        event.preventDefault();
    }

    onValueChange(event: any) {
        this.dateChange.emit(event.target.value);
        this.modelValueChange.emit(event.target.value);
    }

}